export default __webpack_public_path__ + "static/media/close.97180eac.svg";